import React, { useMemo, useCallback } from 'react'
import { Tree, Modal, Icon } from 'antd'
import R from 'ramda'
const getDataMapper = (data, shifts) => {
  const sd = {}
  data
    .filter(dt => dt.shifts === shifts)
    .forEach(dt => {
      const { id } = dt
      const oid = id.substr(
        0,
        id.indexOf('$$') === -1 ? id.length : id.indexOf('$$')
      )

      if (sd[oid]) {
        const ad = sd[oid]
        ad.push(dt)
      } else {
        sd[oid] = [dt]
      }
    })

  // setDataMap(sd)
  return sd
}

const UserTree = ({
  users,
  companyNameMap,
  stationData,
  shifts = 'COMPANY',
  data,
  setUserTreeDialogClose,
  visible,
  defaultExpandAll = false,
  // eslint-disable-next-line no-unused-vars
  ...props
}) => {
  const dataMapper = getDataMapper(data, shifts)
  // const stationMap = useMemo(
  //   _ => R.compose(R.map(s => ({ [s.station]: s.stationName })))(stationData),
  //   [stationData]
  // )
  const stationNameMap = useMemo(
    _ =>
      R.compose(
        R.fromPairs,
        R.map(s => [s.station, s.stationName])
      )(stationData),
    [stationData]
  )

  const sortId = ids => {
    let dt = R.flatten(ids)
    dt = ids.map(i => ({
      id: i,
      name: (shifts === 'COMPANY' ? companyNameMap[i] : stationNameMap[i]) || i,
    }))
    const sor = R.sortWith([R.ascend(R.prop('name'))])(dt)

    return sor
  }

  const getComStaArray = role =>
    role.shifts === 'COMPANY'
      ? (role.resources || {}).company || []
      : (role.resources || {}).station || []

  const getComStrList = roleList => {
    return R.compose(
      sortId,
      R.uniq,
      R.flatten,
      R.map(r => getComStaArray(r))
    )(roleList)
  }
  const getRoleName = useCallback(
    rid => data.find(d => d.id.indexOf(rid) === 0).displayName,
    [data]
  )

  const userNameMap = useMemo(
    _ =>
      R.compose(
        R.reduce((a, b) => ({ ...a, ...b }), {}),
        R.map(usr => ({
          [usr.userName]:
            usr.firstName != null
              ? (usr.firstName || '') +
                ' ' +
                (usr.lastName || '') +
                '(' +
                usr.userName +
                ')'
              : usr.userName,
        }))
      )(users),
    [users]
  )

  const getUserList = useCallback(
    (roleId, comStaId) => {
      const id = roleId + '$$' + comStaId
      return (
        (data.find(d => (d.toggleable ? d.id === id : d.id === roleId)) || {})
          .users || []
      )
    },
    [data]
  )

  const getCommonUsers = useCallback(
    roles => {
      const userArr = roles.map(r => r.users)
      return R.compose(
        R.sortWith([R.ascend(R.prop('name'))]),
        R.map(id => ({ id, name: userNameMap[id] })),
        R.reduce((a, b) => R.intersection(a, b), userArr[0] || [])
      )(userArr)
    },
    [userNameMap]
  )

  return (
    <Modal
      title={'User Role Association - ' + shifts}
      onOk={setUserTreeDialogClose}
      onCancel={setUserTreeDialogClose}
      visible={visible}
      height={500}
      width={700}
      footer={<div />}
    >
      <div style={{ maxHeight: '500px', maxWidth: '700px', overflow: 'auto' }}>
        <Tree
          defaultExpandAll={defaultExpandAll}
          showLine={{ showLeafIcon: false }}
          showIcon
        >
          {Object.keys(dataMapper).map(k => (
            <Tree.TreeNode title={getRoleName(k)} key={k}>
              <Tree.TreeNode title="Common Users" key="comn-users">
                {getCommonUsers(dataMapper[k]).map(({ id, name }) => (
                  <Tree.TreeNode
                    title={name}
                    key={k + 'common' + id}
                    showIcon
                    icon={<Icon type="user" />}
                  />
                ))}
              </Tree.TreeNode>
              {getComStrList(dataMapper[k]).map(c => (
                <Tree.TreeNode title={c.name} key={k + c.id}>
                  {getUserList(k, c.id).map(u => (
                    <Tree.TreeNode
                      title={userNameMap[u]}
                      key={k + c.id + u}
                      isLeaf
                      showIcon
                      icon={<Icon type="user" />}
                    />
                  ))}
                </Tree.TreeNode>
              ))}
            </Tree.TreeNode>
          ))}
        </Tree>
      </div>
    </Modal>
  )
}

export default UserTree
